import { render, staticRenderFns } from "./LinkedinIcon.vue?vue&type=template&id=df4e1422&scoped=true"
import script from "./LinkedinIcon.vue?vue&type=script&lang=js"
export * from "./LinkedinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4e1422",
  null
  
)

export default component.exports